import clsx from 'clsx'
import { FC } from 'react'
import { useIntl } from 'react-intl'

import { APP_NAME, APP_VERSION, WEBSITE_URL } from '@/constants/constant'

import { useLayout } from '../../layouts/core'

const Footer: FC = () => {
  const intl = useIntl()
  const { classes } = useLayout()

  return (
    <div
      className={'footer py-4 d-flex flex-lg-column'}
      id="kt_footer"
    >
      {/*begin::Container*/}
      <div className={clsx(classes.footerContainer, 'd-flex flex-column flex-md-row flex-stack fs-6')}>
        {/*begin::Copyright*/}
        <div className="text-dark">
          <span className="text-gray-400 fw-medium me-1">{intl.formatMessage({ id: 'vocabulary.created_by' })}</span>
          <a
            href={WEBSITE_URL}
            target="_blank"
            className="text-muted text-hover-primary fw-medium me-2 fs-6"
            rel="noreferrer"
          >
            {APP_NAME}
          </a>
        </div>
        {/*end::Copyright*/}

        {/*begin::Menu*/}
        <div>
          <span className="text-gray-400 fw-medium">
            {intl.formatMessage({ id: 'vocabulary.version' })} {APP_VERSION}
          </span>
        </div>
        {/*end::Menu*/}
      </div>
      {/*end::Container*/}
    </div>
  )
}

export { Footer }
